// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxcite_header__1WrAy","info":"Component-pepxcite_info__3FqQe"};